'use client';
import EcoImg from 'eco-design/base/eco-img';
import EditorLink from 'lowcode/components/EditorLink';

export default function Content({ id, data = {}, index = 0 }: any) {
    const { link, bgPc, bgH5 } = data;

    return (
        <>
            <EditorLink className={`glo-bar-item glo-bar-item-${index} glo-bar-type-text`} href={link}>
                <EcoImg pc={bgPc} h5={bgH5} />
            </EditorLink>
        </>
    );
}
